import React, { PureComponent, Fragment } from "react";
import { connect } from 'react-redux';
import { CloseOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Select, Button, Divider } from "antd";
import { PCB_CHANNEL, ROCKY_CHANNEL, SIGN_OFF_TEMPLATE } from "../../../constants/treeConstants";
import { selectTask, updateSelectTaskMessage, getServerList } from '../store/action';
import { getColor, getDefaultSpecifyService, getDisabled, getMsgClassName, getSelectSpanWidth, getTaskDisplay, getTaskServerList, getTitleTree, getVerType, PCB_PROCESSING, TRANSLATION, TRANSLATION_OR_SIMULATION } from '../../../services/CCC/cccHelper';
import { TitleRender } from '@/components/Monitor/TitleRender_v2';
import { PROJECT_D2D, PROJECT_V2 } from "../../../constants/projectVersion";
import '@/publicCss/style.css';
import '@/publicCss/aurora.css';
import './index.css';

class SpecifyServicePanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      verificationList: [],
      verificationType: "Interface",
      selectedVerification: {
        type: "Interface",
        id: "",
        name: "",
        verificationId: ""
      },//{id,name,verificationId}
      selectType: {
        type: "",//PCB_CHANNEL / END_TO_END_CHANNEL / VERIFICATION / ROCKY_CHANNEL
        name: ""
      },
      subSelected: {
        type: "", //DESIGN(andes) / CHANNEL (rocky)
        id: "",
        name: ""
      },
      pcbProcessingWorkerMap: {
        selectedServers: {
          [PCB_PROCESSING]: [],
          [TRANSLATION]: []
        }, // pcb_processing worker selected list
        serverList: [], // pcb_processing worker select options
        selectedProjectId: "", // selected project id
        projectList: [], // project select options
      },
      selectTypeList: [],
      subSelectList: [],
      serviceSelectListMap: {
        verification: [{
          task: "",
          selectedServers: [],
          serverList: []
        }]
      },
      topWidth: 800
    }
  }

  componentDidMount = () => {
    this.props._updateSelectTaskMessage(null);
    this.props._getServerList();
    this.screenChange();
    this.resize();
    const { getCCCVerifications, getCurrentVerification, projectId, setupType, projectVersion } = this.props;
    const { serviceSelectListMap } = this.state;
    let _serviceSelectListMap = { ...serviceSelectListMap };

    const list = getCCCVerifications(projectId);
    const currentVerification = getCurrentVerification();
    const defaultSetup = getDefaultSpecifyService({ list, currentVerification, projectVersion });
    if (setupType === SIGN_OFF_TEMPLATE) {
      _serviceSelectListMap = {
        pathR: [{
          task: "",
          selectedServers: [],
          serverList: []
        }],
        impedance: [{
          task: "",
          selectedServers: [],
          serverList: []
        }]
      }
    }
    this.setState({
      verificationList: defaultSetup.verificationList,
      selectType: defaultSetup.selectType,
      subSelected: defaultSetup.subSelected,
      selectTypeList: defaultSetup.selectTypeList,
      subSelectList: defaultSetup.subSelectList,
      selectedVerification: defaultSetup.verification,
      verificationType: defaultSetup.verificationType,
      list,
      serviceSelectListMap: _serviceSelectListMap
    })
  }

  screenChange() {
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  componentDidUpdate = (prevProps) => {
    const { topWidth } = this.state;
    this.footerRef = document.getElementsByClassName('aurora-footer')[0];
    if (this.footerRef) {
      let width = this.footerRef.offsetWidth;
      if (width !== topWidth) {
        this.setState({
          topWidth: width
        });
      }
    }
  }

  resize = () => {
    this.footerRef = document.getElementsByClassName('tab-footer')[0];

    if (this.footerRef) {
      let width = this.footerRef.offsetWidth;
      this.setState({
        topWidth: width
      });
    }
  }

  selectTypeChange = (key) => {
    const { selectTypeList } = this.state;
    const selectType = selectTypeList.find(item => item.name === key);
    if ([PCB_CHANNEL, ROCKY_CHANNEL].includes(selectType.type)) {
      this.setState({
        selectType: {
          name: selectType.name,
          type: selectType.type
        },
        subSelected: {
          type: selectType.subType,
          id: "",
          name: ""
        },
        subSelectList: selectType.subList || [],
        verificationType: selectType.verificationType,
        verificationList: []
      });
    } else if (selectType.type === TRANSLATION_OR_SIMULATION) {
      const { serverListSimple, projectId } = this.props;
      const findServers = serverListSimple.filter(it => [PCB_PROCESSING, TRANSLATION].includes(it.taskType));
      this.setState({
        selectType: {
          name: selectType.name,
          type: selectType.type
        },
        pcbProcessingWorkerMap: {
          selectedServers: {
            [PCB_PROCESSING]: [],
            [TRANSLATION]: []
          },
          serverList: findServers,
          projectList: selectType.projectList || [],
          selectedProjectId: projectId,
        },
      })
    } else {
      this.setState({
        selectType: {
          name: selectType.name,
          type: selectType.type
        },
        verificationType: selectType.verificationType,
        subSelected: {
          type: "",
          id: "",
          name: ""
        },
        verificationList: selectType.verificationList || []
      })
    }
    this.clearVerification();
  }

  subSelectChange = (key) => {
    const { subSelectList, subSelected, selectType } = this.state;
    const { isGroup, projectVersion } = this.props;
    let subSelect = null, _group = null, subSelectedType = subSelected.type;
    if (isGroup) {
      const [group, value] = key.split("::");
      const findGroup = subSelectList.find(item => item.name === group);
      subSelect = findGroup.children.find(item => item.id === value)
      _group = group;
      subSelectedType = group;
    } else if (selectType.type === PCB_CHANNEL) {
      for (const item of subSelectList) {
        subSelect = item.children.find(it => it.id === key);
        if (subSelect) {
          break;
        }
      }
    } else {
      subSelect = subSelectList.find(item => item.name === key);
    }

    if (!subSelect) {
      return;
    }

    this.setState({
      subSelected: {
        ...subSelected,
        id: subSelect.id,
        name: subSelect.name,
        dataType: isGroup ? _group : "",
        design: subSelect.designName,
        verificationId: [PROJECT_V2, PROJECT_D2D].includes(projectVersion) ? subSelect.verificationId : null,
        type: subSelectedType,
        group: isGroup ? _group : null,
      },
      verificationList: subSelect.verificationList || [],
    })
    this.clearVerification();
    this.props._updateSelectTaskMessage(null);
  }

  verificationChange = (key, label = "name") => {
    const { verificationList } = this.state;
    const VSelect = verificationList.find(item => item[label] === key);
    if (!VSelect) {
      return;
    }
    this.setState({
      selectedVerification: {
        verificationId: VSelect.verificationId,
        id: VSelect.id,
        name: VSelect.name
      }
    })
    this.props._updateSelectTaskMessage(null);
  }

  clearVerification = () => {
    this.setState({
      selectedVerification: {
        id: "",
        name: "",
        verificationId: ""
      }
    })
  }

  serverChange = (keys, index, key) => {
    const { serviceSelectListMap } = this.state;
    let _serviceSelectListMap = { ...serviceSelectListMap };
    let _serviceSelectList = _serviceSelectListMap[key] || [];
    _serviceSelectList[index].selectedServers = [...keys];
    _serviceSelectListMap[key] = _serviceSelectList;
    this.setState({
      serviceSelectListMap: _serviceSelectListMap
    });
    this.props._updateSelectTaskMessage(null);
  }

  taskChange = (value, key, index) => {
    const { serverListSimple } = this.props;
    const { serviceSelectListMap } = this.state;
    let _serviceSelectListMap = { ...serviceSelectListMap };
    let _serviceSelectList = _serviceSelectListMap[key] || [];
    const find = serverListSimple.find(it => it.taskType === value);

    _serviceSelectList[index] = {
      task: value || "",
      selectedServers: [],
      serverList: find ? find.servers : []
    }
    _serviceSelectListMap[key] = _serviceSelectList;
    this.setState({
      serviceSelectListMap: _serviceSelectListMap
    });
    this.props._updateSelectTaskMessage(null);
  }

  addNewTaskSelect = (e, key) => {
    e.stopPropagation();
    const { serviceSelectListMap } = this.state;
    let _serviceSelectListMap = { ...serviceSelectListMap };
    let _serviceSelectList = _serviceSelectListMap[key] || []
    _serviceSelectList.push({
      task: "",
      selectedServers: [],
      serverList: []
    });
    _serviceSelectListMap[key] = _serviceSelectList;
    this.setState({
      serviceSelectListMap: _serviceSelectListMap
    });
    this.props._updateSelectTaskMessage(null);
  }

  deleteSelectedTask = (taskIndex, key) => {
    const { serviceSelectListMap } = this.state;
    let _serviceSelectListMap = { ...serviceSelectListMap };
    let _serviceSelectList = _serviceSelectListMap[key] || [];
    _serviceSelectList = _serviceSelectList.filter((item, index) => index !== taskIndex);
    _serviceSelectListMap[key] = _serviceSelectList;
    this.setState({
      serviceSelectListMap: _serviceSelectListMap
    });
    this.props._updateSelectTaskMessage(null);
  }

  selectTask = () => {
    const { selectedVerification, serviceSelectListMap, subSelected, selectType, pcbProcessingWorkerMap } = this.state;
    const { projectVersion, setupType } = this.props;
    let _selectedKey = { ...selectedVerification }
    if (selectType.type === TRANSLATION_OR_SIMULATION) {
      this.props._selectTask({}, null, setupType, pcbProcessingWorkerMap);
      return;
    } else if ([PROJECT_V2, PROJECT_D2D].includes(projectVersion)) {
      _selectedKey = { ...subSelected }
    }
    this.props._selectTask(_selectedKey, serviceSelectListMap, setupType);
  }

  getTitleTree = (titleSelectedKeys) => {
    const { pageType } = this.props;
    return getTitleTree(titleSelectedKeys, pageType);
  }

  selectPCBProcessingWorker = (_, options) => {
    this.setState((prevState) => {
      const pcbProcessing = options.filter(it => it.taskType === PCB_PROCESSING).map(it => it.value);
      const translation = options.filter(it => it.taskType === TRANSLATION).map(it => it.value);
      return {
        pcbProcessingWorkerMap: {
          ...prevState.pcbProcessingWorkerMap,
          selectedServers: {
            [PCB_PROCESSING]: pcbProcessing,
            [TRANSLATION]: translation
          },
        }
      }
    })
  }

  selectProject = (value) => {
    this.setState((prevState) => {
      return {
        pcbProcessingWorkerMap: {
          ...prevState.pcbProcessingWorkerMap,
          selectedProjectId: value,
        }
      }
    })
  }

  render() {
    const { selectTaskMessage, titleSelectedKeys, isGroup, projectVersion } = this.props;
    const { verificationType, topWidth, subSelected, subSelectList,
      selectType, selectTypeList, selectedVerification,
      verificationList, serviceSelectListMap, pcbProcessingWorkerMap } = this.state;
    const width = getSelectSpanWidth(selectType.type, verificationType);
    return <Fragment>
      <div className="specify-service-project-title">
        {TitleRender({
          topWidth,
          progress: -1,
          monitorTree: this.getTitleTree(titleSelectedKeys),
          selectedKey: titleSelectedKeys.map(item => item.name).filter(item => !!item),
          displayList: titleSelectedKeys.filter(item => !!item.name)
        })}
      </div>
      <div className='specify-service-content'>
        <div className='specify-service-main'>
          <div className='specify-service-title'>Specify Service Selector</div>
          {selectTypeList && selectTypeList.length > 1 ? this.selectComponent({
            title: "Type",
            value: selectType.name,
            options: selectTypeList,
            width,
            selectChange: this.selectTypeChange
          }) : null}
          {selectType.name === TRANSLATION_OR_SIMULATION
            ? <>
              {this.selectComponent({
                title: "Project",
                value: pcbProcessingWorkerMap.selectedProjectId,
                options: pcbProcessingWorkerMap.projectList,
                width,
                selectChange: this.selectProject,
                labelInValue: false,
              })}
              {this.serverSelectRender({
                label: "PCB Processing Worker",
                selectedServers: [
                  ...pcbProcessingWorkerMap.selectedServers[PCB_PROCESSING],
                  ...pcbProcessingWorkerMap.selectedServers[TRANSLATION]
                ],
                serverList: pcbProcessingWorkerMap.serverList,
                width,
                selectChange: this.selectPCBProcessingWorker,
                allowGroup: true
              })}
            </>
            : <>
              {subSelected.type ? this.selectComponent({
                title: subSelected.type,
                dataType: subSelected.dataType,
                value: isGroup ? subSelected.id : subSelected.id || subSelected.name,
                name: subSelected.name,
                options: subSelectList,
                width,
                label: subSelected.design,
                selectChange: this.subSelectChange,
                allowGroup: true,
                isGroup,
                group: subSelected.group
              }) : null}
              {![PROJECT_V2, PROJECT_D2D].includes(projectVersion) ? this.selectComponent({
                title: verificationType,
                value: isGroup ? selectedVerification.id : selectedVerification.id || selectedVerification.name,
                name: selectedVerification.name,
                options: verificationList,
                width,
                selectChange: this.verificationChange,
                isId: isGroup || selectType.type === PCB_CHANNEL,
              }) : null}
              {Object.keys(serviceSelectListMap || {}).map(item => this.taskServerRender(item, width))}
            </>}
          <div className='specify-service-item specify-service-button-content'>
            <Button
              className='specify-service-button'
              type='primary'
              onClick={this.selectTask}
              disabled={this.getDisabled()}
            >Select</Button>
          </div>
          {selectTaskMessage && <div className={`specify-service-item specify-service-message-content ${getMsgClassName(selectTaskMessage)}`}>
            {selectTaskMessage}
          </div>}
        </div>
      </div>
    </Fragment>
  }

  getDisabled = () => {
    const { selectedVerification, serviceSelectListMap, subSelected, selectType, pcbProcessingWorkerMap } = this.state;
    const { projectVersion } = this.props;
    return getDisabled({
      selectedVerification,
      serviceSelectListMap,
      subSelected,
      selectType: selectType.type,
      pcbProcessingWorkerMap,
      projectVersion,
    })
  }

  getStatus = (value, name) => {
    const str = value ? value.replace(/^\S/, s => s.toUpperCase()) : '';
    return <div>
      <span >{name} - </span>
      <span style={{ color: getColor(value), fontWeight: 'bold' }}>{str}</span>
    </div>
  }

  selectComponent = ({ title, value, options, selectChange, width, dataType, label, allowGroup, isId, name, labelInValue = true, isGroup, group }) => {
    return <div className='specify-service-item'>
      <span>{title}</span>
      {labelInValue
        ? <Select
          value={{
            value: group ? `${group}::${value}` : dataType ? `${dataType}::${value}` : value || "",
            label: label ? name && value ? `${label} - ${name}` : `${label} - ${value}` || value : name && value ? name : value || ""
          }}
          showSearch
          labelInValue={true}
          onChange={option => option && selectChange(option.value, isId ? "id" : "name")}
          placeholder={title}
          classNames={{ popup: { root: 'aurora-select-dropdown' } }}
          style={{ width: `calc(100% - ${width}px` }}
          options={options.map(item => {
            if (item.children && allowGroup) {
              return {
                label: item.name || item.label,
                // value: item.name,
                options: item.children.map(it => ({
                  title: it.name,
                  label: isGroup ? (item.name === "Interface" ? it.name : `${it.designName} - ${it.name}`) : it.name,
                  value: isGroup ? `${item.name}::${it.id}` : it.id,
                }))
              }
            }
            return {
              title: item.name,
              label: item.name,
              value: isId ? item.id : item.name
            };
          })}
        />
        : <Select
          value={value}
          showSearch
          onChange={value => selectChange(value)}
          placeholder={title}
          classNames={{ popup: { root: 'aurora-select-dropdown' } }}
          style={{ width: `calc(100% - ${width}px` }}
          options={options.map(item => ({
            title: item.name,
            label: item.name,
            value: item.id
          }))}
        />
      }

    </div>
  }

  taskServerRender = (key, width) => {
    const { serverListSimple, pageType, setupType, projectVersion } = this.props;
    const { serviceSelectListMap, verificationType, subSelected } = this.state;
    const itemData = serviceSelectListMap[key] || [];
    const _setupType = key === "verification" ? setupType : key;
    const taskServerList = getTaskServerList(serverListSimple, itemData, pageType, verificationType, _setupType, projectVersion, subSelected);
    const isMulti = Object.keys(serviceSelectListMap).length > 1;
    const className = isMulti ? "specify-service-sub-item" : "";
    return itemData.map((service, index) => {
      return (
        <Fragment key={index}>
          <div className='specify-service-task-content' key={index}>
            {isMulti && index === 0 ? <div className='specify-service-item'>
              <span className="server-title">{getVerType(key)}</span>
            </div> : null}
            <div className={`specify-service-item ${className}`}>
              <span>
                <span>Task</span>
                {index === 0 ? <PlusCircleOutlined
                  title='Add new Task'
                  className='specify-service-add-task-icon'
                  onClick={(e) => { this.addNewTaskSelect(e, key) }} /> : null}
              </span>
              <Select
                value={getTaskDisplay(service.task)}
                onChange={(_key) => this.taskChange(_key, key, index)}
                classNames={{ popup: { root: 'aurora-select-dropdown' } }}
                allowClear={true}
                style={{ width: `calc(100% - ${width}px` }}
                options={taskServerList.map(item => ({
                  value: item.taskType,
                  label: getTaskDisplay(item.taskType),
                  title: item.taskType,
                }))}
              />
            </div>
            {this.serverSelectRender({
              label: "Services",
              width,
              className,
              index,
              key,
              selectedServers: service.selectedServers,
              serverList: service.serverList,
              selectChange: (keys) => this.serverChange(keys, index, key)
            })}
            {itemData.length === 1 ? null :
              <CloseOutlined
                title={'Delete the task'}
                className='specify-service-delete-task-icon'
                onClick={() => { this.deleteSelectedTask(index, key) }} />}
          </div>
          {(itemData.length - 1) !== index ?
            <Divider dashed /> : null}
        </Fragment>
      );
    });
  }

  serverSelectRender = ({ label, width, className, selectedServers, serverList, selectChange, allowGroup }) => {
    return <div className={`specify-service-item ${className}`}>
      <span>{label}</span>
      <Select
        mode="multiple"
        value={selectedServers}
        onChange={(keys, option) => selectChange(keys, option)}
        classNames={{ popup: { root: 'aurora-select-dropdown' } }}
        popupMatchSelectWidth={false}
        style={{ width: `calc(100% - ${width}px` }}
        options={serverList.map(item => {
          if (allowGroup) {
            return {
              label: item.taskType,
              options: item.servers.map(it => ({
                title: it.name,
                label: this.getStatus(it.status, it.name),
                value: it.name,
                taskType: item.taskType,
              }))
            }
          }
          return {
            value: item.name,
            label: this.getStatus(item.status, item.name),
            title: item.name
          }
        })}
      />
    </div>
  }
}

const mapState = (state) => {
  const { serverListSimple = [], selectTaskMessage } = state.CCCReducer;
  const { pageType } = state.LoginReducer;

  return {
    serverListSimple,
    selectTaskMessage,
    pageType
  }
}

const mapDispatch = (dispatch) => ({
  _selectTask(verification, serviceSelectListMap, setupType, pcbProcessingWorkerMap) {
    dispatch(selectTask(verification, serviceSelectListMap, setupType, pcbProcessingWorkerMap))
  },
  _updateSelectTaskMessage(msg) {
    dispatch(updateSelectTaskMessage(msg))
  },
  _getServerList() {
    dispatch(getServerList());
  },
})

export default connect(mapState, mapDispatch)(SpecifyServicePanel)